<template>
    <div class="col-lg-10 col-md-8 col-12 main">
        <!-- <Swiper :list="list" /> -->
        <img v-for="(item, index) in list" :key="index" :src="item.img" :alt="item.alt" style="width: 100%; margin-bottom: 0px;" />
    </div>
</template>
<script>
// import Swiper from "@/components/Swiper.vue";
export default {
    name: "home",
    components: {
        // Swiper
    },
    data() {
        return {
            // list: [
            //     { img: require("@/assets/resource/visual_art/drawings/1.png"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/2.png"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/3.png"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/4.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/5.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/7.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/8.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/9.png"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/10.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/11.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/12.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/13.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/14.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/15.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/16.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/17.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/18.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/19.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/20.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/21.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/22.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/23.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/24.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/25.jpg"), alt: "123" },
            //     { img: require("@/assets/resource/visual_art/drawings/26.jpg"), alt: "123" },
            // ],

            list: [
                { img: require("@/assets/resource/visual_art/drawings2/1.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/drawings2/2.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/drawings2/3.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/drawings2/4.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/drawings2/5.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/drawings2/6.jpg"), alt: "123" },
                { img: require("@/assets/resource/visual_art/drawings2/7.jpg"), alt: "123" },
            ],            
        }
    },


};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main {
    height: 100vh;
    padding: 30px 15px;
}

@media (max-width: 768px) {
    .main {
        padding-top: 0px;
        height: calc(100vh - 90px);
    }

}
</style>